import React from "react";
import { UPDATE_FEED_COMMENT } from "../../apollo/operations";
import { useMutation } from "@apollo/client";
import { UserFeeedCommentTypes } from "../../types";
import { CommentEdit } from "..";

type UserCommentContentProps = {
  userComment: string | undefined;
  userFeed: UserFeeedCommentTypes | undefined;
  refetch: () => void;
  openEdit: boolean;
  handleCloseEdit: () => void;
  pImage?: string;
};
const UserCommentContent: React.FC<UserCommentContentProps> = ({
  userComment,
  userFeed,
  refetch,
  openEdit,
  handleCloseEdit,
  pImage,
}) => {
  const [editedComment, setEditedComment] = React.useState(userComment);
  const maxLength = 300;
  const [isExpanded, setIsExpanded] = React.useState(false);

  const [updateComment, { loading }] = useMutation(UPDATE_FEED_COMMENT, {
    onCompleted(data) {
      if (refetch) {
        refetch();
      }
    },
    onError: (err) => {
      console.log(err.message, "update error");
      const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(errorMessage);
    },
  });

  const handleUpdateComment = (e: any) => {
    e.preventDefault();
    updateComment({
      variables: {
        data: {
          comments: editedComment!,
        },
        where: {
          id: userFeed?.id,
        },
      },
    }).then(() => {
      handleCloseEdit();
      console.log("successful");

      localStorage.setItem("commentEditedFlag", "boolean");
    });
  };

  return (
    <>
      {!loading && (
        <div className="pr-5 pl-2 font-Rubik text-[10px] lg:text-sm font-normal w-full block whitespace-pre-line break-words text-justify text-[#646464]">
          {/* {userComment} */}
          {userComment && userComment.length <= maxLength
            ? userComment
            : isExpanded
            ? userComment
            : userComment?.slice(0, maxLength)}
          {userComment && userComment.length > maxLength && (
            <span
              className="cursor-pointer font-extralight text-[10px] pl-2 font-SegoeUI text-greyText"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {!isExpanded ? "... See more" : " ... See less"}
            </span>
          )}
        </div>
      )}

      {openEdit && (
        <CommentEdit
          userFeed={userFeed}
          pImage={pImage}
          handleUpdateComment={handleUpdateComment}
          handleCloseEdit={handleCloseEdit}
          loading={loading}
          setEditedComment={setEditedComment}
          editedComment={editedComment}
        />
      )}
    </>
  );
};

export default UserCommentContent;
